module.exports = __webpack_public_path__ + "img/shiplogosmall.34896335.png";